import { getCookie } from './cookies';

export const API_BASE = (process.env.REACT_APP_API_URL || 'https://kisandailyfresh.in').replace(/\/+$/, '');

export const buildApiUrl = (path = '') => {
  if (/^https?:\/\//i.test(path)) return path;
  return `${API_BASE}/${String(path).replace(/^\/+/, '')}`;
};

export const buildAssetUrl = (assetPath) => {
  if (!assetPath) return null;
  if (/^https?:\/\//i.test(assetPath)) return assetPath;
  return buildApiUrl(assetPath);
};

// Central fetch — attaches auth token, parses JSON, throws on API errors
export const apiFetch = async (path, { body, method = 'GET', auth = true, ...opts } = {}) => {
  const url = buildApiUrl(path);

  const headers = { ...(opts.headers || {}) };
  if (body !== undefined) headers['Content-Type'] = 'application/json';
  if (auth) {
    const token = getCookie('authToken');
    if (token) headers['Authorization'] = `Bearer ${token}`;
  }

  const res = await fetch(url, {
    method,
    headers,
    ...(body !== undefined ? { body: JSON.stringify(body) } : {}),
  });

  const json = await res.json();

  if (!res.ok || json.success === false) {
    throw new Error(json.message || `Request failed with status ${res.status}`);
  }

  return json;
};
